enum ReportStep {
  SelectADataType = 'selectADataType',
  Filter = 'filter',
  Report = 'report',
}

export const ReportSteps: string[] = Object.values(ReportStep)

export default ReportStep
